import React, { useEffect, useState } from "react";
import { useIntl } from "react-intl";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

//Components
import { Button, SidePanel, SidePanelBody, SidePanelFooter, SidePanelHeader } from '@gpstrackit/gtc-react-controls';

//Actions
import { reset } from "Modules/driverPerformance/views/cases/modals/viewCreationPanel/redux/slice";
import { setDriverPerformanceMainTab } from 'Redux/actions';

//Styles
import './style.scss';

const ViewCreationPanel = () => {
    const dispatch = useDispatch();
    const { messages } = useIntl();
    const { loading, open, dataCreation = { label: '', value: 0 } } = useSelector(state => state.driverPerformanceCasesTabViewCreationPanelRedux || {});
    const [listData, setListData] = useState([]);
    const [cases, setCases] = useState([]);

    const navigate = useNavigate()

    // Clickable fields
    const clickableFields = ['casesCreated', 'casesUpdated', 'casesNoCoachAssigned'];

    // Label to type mapping
    const labelToTypeMap = {
        'casesCreated': 'create',
        'casesUpdated': 'update',
        'casesNoCoachAssigned': 'noCoach'
    };

    const filterCasesByType = (type) => {
        if (!cases || cases.length === 0) return [];

        // Filter cases by type
        const filteredCases = cases.filter(caseItem => caseItem.type === type);

        // Remove duplicates based on caseNumber
        const uniqueCases = filteredCases.reduce((acc, current) => {
            const exists = acc.find(item => item.caseNumber === current.caseNumber);
            if (!exists) {
                acc.push(current);
            }
            return acc;
        }, []);

        return uniqueCases;
    };

    const handleFieldClick = (label, value) => {
        if (clickableFields.includes(label) && value > 0) {
            const type = labelToTypeMap[label];
            const filteredCases = filterCasesByType(type);
            // Build query string with caseNumbers
            const params = new URLSearchParams();

            // Extract caseNumbers and add them as parameters
            const caseNumbers = filteredCases.map(caseItem => caseItem.caseNumber);
            if (caseNumbers.length > 0) {
                params.set('caseNumbers', caseNumbers.join(','));

                const queryString = params.toString();
                const finalUrl = `/app/driverPerformance/main?${queryString}`;
                navigate(finalUrl);
                dispatch(setDriverPerformanceMainTab(3));
                dispatch(reset({ open: false }))
            }
        }
    };

    const isClickable = (label, value) => {
        return clickableFields.includes(label) && value > 0;
    };

    useEffect(() => {
        if (open && dataCreation) {
            // Extract cases and store them in local state
            const { cases: casesData, timeExecutedMinutes, ...restData } = dataCreation;

            // Save cases in local state
            if (casesData) {
                setCases(casesData);
            }

            // Create listData without the cases property
            setListData(Object.entries(restData).map(([label, value]) => ({
                label,
                value
            })));
        }
    }, [open])

    return (
        <SidePanel isOpen={open} hiddenButton={true} style={{ width: '450px', transform: 'translateX(450px)' }}>
            <SidePanelHeader>
                <label className="create-casesTap-panel__title">{messages['driver_performance_cases_view_createCasesResult']}</label>
            </SidePanelHeader>
            <SidePanelBody>
                {
                    listData?.length > 0 &&
                    (
                        <div className={'view-create-cases-div'}>
                            {listData.map((data) => (
                                <ul
                                    key={data.key}
                                    className={'view-create-cases-body'}
                                    style={{
                                        listStyle: 'none',
                                    }}
                                >
                                    <li className={'view-create-cases-label'}>{messages['driver_performance_cases_view_' + data.label]}</li>
                                    <li
                                        className={`view-create-cases-value ${isClickable(data.label, data.value) ? 'view-create-cases-value--clickable' : ''}`}
                                        onClick={() => handleFieldClick(data.label, data.value)}
                                        style={{
                                            cursor: isClickable(data.label, data.value) ? 'pointer' : 'default',
                                            color: isClickable(data.label, data.value) ? '#1a73e8' : 'inherit',
                                            textDecoration: isClickable(data.label, data.value) ? 'underline' : 'none',
                                        }}
                                    >
                                        {data.value}
                                    </li>
                                </ul>
                            ))}
                        </div>
                    )
                }
            </SidePanelBody>
            <SidePanelFooter>
                <div style={{ display: 'flex', justifyContent: 'end' }}>
                    <Button
                        isDisabled={loading}
                        style={{ marginRight: 8 }}
                        onClick={() => dispatch(reset({ open: false }))}
                        variant="secondary">
                        {messages["driver_performance_cases_view_close"]}
                    </Button>
                </div>
            </SidePanelFooter>
        </SidePanel>
    )
}

export default ViewCreationPanel
